import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'fi-manual-sharing-selection-info-container',
    template: `
        <mat-icon class="far fa-circle-exclamation" />
        <span class="manual-sharing-selection-info">{{ infoText }}</span>
    `,
    styleUrl: './fi-manual-sharing-selection-info-container.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-manual-sharing-selection-info-container' },
    standalone: false,
})
export class FiManualSharingSelectionInfoContainerComponent {
    @Input() infoText: string = '';
}
